module.exports = require('./UserDetailModal');